import { render, staticRenderFns } from "./OrderQrCode.vue?vue&type=template&id=6b6fc522&scoped=true"
import script from "./OrderQrCode.vue?vue&type=script&lang=js"
export * from "./OrderQrCode.vue?vue&type=script&lang=js"
import style0 from "./OrderQrCode.vue?vue&type=style&index=0&id=6b6fc522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fc522",
  null
  
)

export default component.exports